import React, { useState } from 'react';
import './Bot.css';

export default function Bot() {
    const [isOpen, setIsOpen] = useState(false);

    const services = [
        { id: 'messenger', icon: 'fa fa-comments', label: 'Message', href: '#', color: '#ff6600' },
        { id: 'whatsapp', icon: 'bi bi-whatsapp', label: 'WhatsApp', href: 'https://api.whatsapp.com/send?phone=918421367454&text=hi', color: '#17ea5e' },
        { id: 'call', icon: 'fa fa-phone', label: 'Call', href: 'tel:8421367454', color: '#0084ff' },
    ];

    return (
        <div id="whatsapp-widget">
            <div id="sy-whatshelp">
                <div className={`sywh-services ${isOpen ? 'active' : ''}`}>
                    {services.map((service, index) => (
                        <a
                            key={service.id}
                            href={service.href}
                            className={service.id}
                            data-tooltip={service.label}
                            data-placement="left"
                            target="_blank"
                            rel="noreferrer"
                            style={{ 
                                transitionDelay: isOpen ? `${index * 0.1}s` : '0s',
                                backgroundColor: service.color 
                            }}
                        >
                            <i className={service.icon}></i>
                        </a>
                    ))}
                </div>

                <button
                    className={`sywh-open-services ${isOpen ? 'active' : ''}`}
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <i className="fa fa-handshake open-icon"></i>
                    <i className="fa fa-times close-icon"></i>
                </button>
            </div>
        </div>
    );
}